import * as React from 'react';

import { Button } from '@gearbelt/ui/components';

import { cn } from '@/lib/utils';

interface ButtonStateToggleOption<T = string> {
  icon: React.ReactNode;
  label: string;
  value: T;
}

interface ButtonStateToggleProps<T = string> {
  options: ButtonStateToggleOption<T>[];
  value: T;
  onChange: (value: T) => void;
}

const ButtonStateToggleVertical = <T,>({ options, value, onChange }: ButtonStateToggleProps<T>) => {
  if (options.length < 2) {
    throw new Error('ButtonStateToggle requires at least 2 options');
  }

  return (
    <div className="flex flex-col gap-1">
      {options.map((option, index) => (
        <Button
          key={index}
          variant={value === option.value ? 'default' : null}
          aria-pressed={value === option.value}
          className={cn('justify-start rounded-md p-1', value !== option.value && 'hover:bg-grey-1')}
          onClick={() => onChange(option.value)}
          icon={option.icon}>
          {option.label}
        </Button>
      ))}
    </div>
  );
};

export { ButtonStateToggleVertical, type ButtonStateToggleOption };
